module.exports = __webpack_public_path__ + "img/1970East-052_WEB-min.05fe4862.jpg";